import { axiosApi } from 'shared/api/axios'
import { OrderHistoryEndpoint } from 'entities/orderHistory/api/constants'
import { OrderHistoryEventDTO } from 'entities/orderHistory/model/dtoTypes'
import { OrderHistoryEvent } from 'entities/orderHistory/model/types'
import { adaptOrderHistoryDTO } from 'entities/orderHistory/model/adapters'

export const getOrderHistory = async (
    orderId: number,
): Promise<OrderHistoryEvent[]> => {
    try {
        const response = await axiosApi.get<OrderHistoryEventDTO[]>(
            `${OrderHistoryEndpoint.orderHistory}${orderId}?limit=1000`,
        )
        return response.data.map(adaptOrderHistoryDTO)
    } catch (err) {
        console.error(err)
        throw new Error('Ошибка создания заказа')
    }
}
